<template>
  <b-col
    :cols="6"
    :md="3"
    class="py-3">
    <b-card
      class="category-thumbnail text-center"
      :img-src="imgSrc"
      img-alt="Image"
      img-top
      @click="handleCardClick">
      <b-card-text>
        <span class="h5">
          {{name}}
        </span>
      </b-card-text>
    </b-card>
  </b-col>
</template>

<script>
export default {
  name: 'CategoryThumbnail',
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    linkCategory: {
      type: String,
      required: true,
    },
    linkSubcategory: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleCardClick() {
      this.$router.push({
        path: 'listings',
        query: {
          category: this.linkCategory,
          subcategory: this.linkSubcategory,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.category-thumbnail {
  cursor: pointer;
}
</style>
